import { jsx as originalJsx, jsxs as originalJsxs, Fragment } from 'beda-original-jsx';

export function bedaConfig() {
  return (globalThis as any).__BEDA_CONFIG__ || (globalThis as any).bedaTheme || {};
}

export function bedaUrl(value: string) {
  const config = bedaConfig();
  if (value.startsWith('/images/') || value === '/favicon.svg') return (config.assets || '') + value;
  if (value.startsWith('/') && !value.startsWith('//')) return (config.home || '') + value;
  const original = 'https://beda-healthcare.lutengano89.chatgpt.site';
  if (value === original || value.startsWith(original + '/')) return (config.home || original) + value.slice(original.length);
  return value;
}

function adaptProps(props: any) {
  if (!props) return props;
  const output = { ...props };
  for (const field of ['href', 'src', 'action', 'poster']) {
    if (typeof output[field] === 'string') output[field] = bedaUrl(output[field]);
  }
  for (const field of ['srcSet', 'imageSrcSet']) {
    if (typeof output[field] === 'string') output[field] = output[field].split(',').map((entry: string) => {
      const match = entry.trim().match(/^(\S+)(.*)$/);
      return match ? bedaUrl(match[1]) + match[2] : entry;
    }).join(', ');
  }
  if (output.dangerouslySetInnerHTML && typeof output.dangerouslySetInnerHTML.__html === 'string') {
    const original = 'https://beda-healthcare.lutengano89.chatgpt.site';
    output.dangerouslySetInnerHTML = { __html: output.dangerouslySetInnerHTML.__html.split(original).join(bedaConfig().home || original) };
  }
  return output;
}

export { Fragment };
export function jsx(type: any, props: any, key?: string) { return originalJsx(type, adaptProps(props), key); }
export function jsxs(type: any, props: any, key?: string) { return originalJsxs(type, adaptProps(props), key); }
